import store from '@/plugins/vuex'

const routes = [
  {
    path: '/label/content-id/overview',
    name: 'Content ID Overview Label',
    component: () =>
      import(/* webpackChunkName: 'content-id-overview-label' */ './views/Overview.vue')
  },
  {
    path: '/label/content-id/clients',
    name: 'Content ID Clients Label',
    component: () =>
        import(/* webpackChunkName: 'content-id-clients-label' */ './views/Clients.vue')
  }
]

export default routes
